module.exports = __webpack_public_path__ + "img/pen-solid.162408a1.svg";